import React from 'react'
import MultiStepForms from '../Pages/MultiStepForm/MultiStepForm';
import UpperNavbar from '../Pages/Dashboard/UpperNavbar';
import '../Pages/Dashboard/Dashboard.css'
import SideBar from '../Pages/Dashboard/SideBar';
import '../Pages/Dashboard/Dashboard.css'
function MultiStepForm() {
  return (
    <div className='paymentPage'>
    <div style={{ display: 'flex', height: '100vh', overflow: 'scroll initial', width: '100%' }}>
        <div>
            {/* <SideBar /> */}
        </div>
        <div style={{ width: '100%', height: '100vh' }}>
            <UpperNavbar />
            <div style={{ backgroundColor: '#f1f3fa', width: '100%', height: '90vh', overflow: 'scroll' }}>
                       
                <MultiStepForms/>
            </div>
        </div>
    </div>
</div>
  )
}

export default MultiStepForm